// @ts-nocheck
import {
  CLEAR_SCHEDULE_DATA,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST,
  FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS,
  FETCH_CONTRACTOR_LOGS_FAILURE,
  FETCH_CONTRACTOR_LOGS_REQUEST,
  FETCH_CONTRACTOR_LOGS_SUCCESS,
  UPDATE_SCHEDULE_DATA,
} from "../constants/contractorScheduleTabConstants";
import {
  ASSIGN_CLIENT_FAILURE,
  ASSIGN_CLIENT_REQUEST,
  ASSIGN_CLIENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  SEARCH_NEW_EVENT_FAILURE,
  SEARCH_NEW_EVENT_REQUEST,
  SEARCH_NEW_EVENT_SUCCESS,
  SET_MULTIPLE_FIELDS_EVENT_REQUEST,
  UPDATE_CONTACT_INFORMATION_FAILURE,
  UPDATE_CONTACT_INFORMATION_REQUEST,
  UPDATE_CONTACT_INFORMATION_SUCCESS,
  UPDATE_EVENT_INFORMATION_FAILURE,
  UPDATE_EVENT_INFORMATION_REQUEST,
  UPDATE_EVENT_INFORMATION_SUCCESS,
} from "../constants/eventRequest";
import {
  EVENT_EDITED_AFTER_ESTIMATE_FAILURE,
  EVENT_EDITED_AFTER_ESTIMATE_REQUEST,
  EVENT_EDITED_AFTER_ESTIMATE_SUCCESS,
} from "../constants/eventRequestDetails";
import {
  FETCH_SINGLE_POSITION_DATA_FAILURE,
  FETCH_SINGLE_POSITION_DATA_REQUEST,
  FETCH_SINGLE_POSITION_DATA_SUCCESS,
} from "../constants/schedule";

const initialState = {
  schedules: {
    data: [],
    isLoading: false,
    currentPage: null,
    totalPages: null,
    totalItems: null,
    startDate: "",
    endDate: "",
  },
  individualPosition: {
    eventLogs: null,
    data: null,
    isLoading: false,
  },
  isLoading: false,
  ucLoading: false,
};

const contractorScheduleTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MULTIPLE_FIELDS_EVENT_REQUEST:
      return {
        ...state,
        ...action?.payload,
      };

    case FETCH_CONTRACTOR_ASSIGNED_POSITIONS_REQUEST:
      return {
        ...state,
        schedules: {
          ...state?.schedules,
          startDate: action?.payload?.startDate,
          endDate: action?.payload?.endDate,
          isLoading: true,
        },
      };

    case FETCH_CONTRACTOR_ASSIGNED_POSITIONS_SUCCESS:
      return {
        ...state,
        schedules: {
          ...state?.schedules,
          data: action.payload?.schedules,
          currentPage: action.payload?.currentPage,
          totalPages: action.payload?.totalPages,
          totalItems: action.payload?.totalItems,
          isLoading: false,
        },
      };

    case FETCH_CONTRACTOR_ASSIGNED_POSITIONS_FAILURE:
      return {
        ...state,
        schedules: {
          ...state?.schedules,
          isLoading: false,
        },
      };

    // fetch single position details...
    case FETCH_SINGLE_POSITION_DATA_REQUEST:
      return {
        ...state,
        individualPosition: {
          ...state?.individualPosition,
          isLoading: true,
        },
      };
    case FETCH_SINGLE_POSITION_DATA_FAILURE:
      return {
        ...state,
        individualPosition: {
          ...state?.individualPosition,
          data: null,
          isLoading: false,
        },
      };
    case FETCH_SINGLE_POSITION_DATA_SUCCESS:
      return {
        ...state,
        individualPosition: {
          ...state?.individualPosition,
          eventLogs: action?.payload?.logData?.logsData,
          data: action?.payload?.data,
          isLoading: false,
        },
      };

    // search new event request
    case SEARCH_NEW_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_NEW_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        schedules: action.payload?.schedules,
      };
    case SEARCH_NEW_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // assing client request
    case ASSIGN_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ASSIGN_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case ASSIGN_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // event edited after estimate is generated
    case EVENT_EDITED_AFTER_ESTIMATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case EVENT_EDITED_AFTER_ESTIMATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case EVENT_EDITED_AFTER_ESTIMATE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // update contact information
    case UPDATE_CONTACT_INFORMATION_REQUEST:
      return {
        ...state,
        ucLoading: true,
      };
    case UPDATE_CONTACT_INFORMATION_SUCCESS:
      return {
        ...state,
        ucLoading: false,
      };
    case UPDATE_CONTACT_INFORMATION_FAILURE:
      return {
        ...state,
        ucLoading: false,
      };

    // update event information
    case UPDATE_EVENT_INFORMATION_REQUEST:
      return {
        ...state,
        ucLoading: true,
      };
    case UPDATE_EVENT_INFORMATION_SUCCESS:
      return {
        ...state,
        ucLoading: false,
      };
    case UPDATE_EVENT_INFORMATION_FAILURE:
      return {
        ...state,
        ucLoading: false,
      };

    // delete event request
    case DELETE_EVENT_REQUEST:
      return {
        ...state,
      };
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
      };
    case DELETE_EVENT_FAILURE:
      return {
        ...state,
      };

    // clear schedule data
    case CLEAR_SCHEDULE_DATA:
      return {
        ...initialState,
      };

    // update schedule data
    case UPDATE_SCHEDULE_DATA:
      return {
        ...state,
        individualPosition: {
          ...state?.individualPosition,
          data: {
            ...state?.individualPosition?.data,
            reImbursement: action?.payload?.reImbursement,
          },
        },
      };

    // fetch only logs
    case FETCH_CONTRACTOR_LOGS_REQUEST:
      return {
        ...state,
      };
    case FETCH_CONTRACTOR_LOGS_SUCCESS:
      return {
        ...state,
        individualPosition: {
          ...state?.individualPosition,
          eventLogs: [
            action?.payload?.data?.[0],
            ...(state?.individualPosition?.eventLogs || []),
          ],
        },
      };

    case FETCH_CONTRACTOR_LOGS_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default contractorScheduleTabReducer;
export {
  initialState
}